<template>
  <div>
    <component
      v-if="specialty"
      :is="componentName"
      @formSubmit="onFormSubmit"
      @formCancel="onFormCancel"
      :initial-data="specialty"
    />
    <div v-else class="text-center">
      <b-spinner variant="success" label="Loading..." />
    </div>
  </div>
</template>

<script>
import Api from '@/providers/Api.js';
import SpecialtyForm from '@/components/specialty/SpecialtyForm';
import { UPDATE_SPECIALTY_MUTATION } from '@/store';
import MasterSpecialtyForm from '@/components/specialty/MasterSpecialtyForm';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'SpecialtyEdit',
  components: {
    SpecialtyForm,
    MasterSpecialtyForm,
  },
  props: {
    isMaster: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      specialty: null,
    };
  },
  created() {
    Api.getSpecialty(this, this.$route.params.specialtyId).then((s) => {
      this.specialty = s;
    });
  },
  computed: {
    componentName: function () {
      return this.isMaster ? MasterSpecialtyForm.name : SpecialtyForm.name;
    },
  },
  methods: {
    onFormSubmit: async function (data) {
      try {
        const updatedSpecialty = await Api.updateSpecialty(data);
        this.$store.commit(UPDATE_SPECIALTY_MUTATION, updatedSpecialty);
        this.$toasted.success('Specialty saved', { duration: 3000 });
        this.$router.go(-1);
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
        handleServerErrorWithValidation(e, this.$toasted);
      }
    },
    onFormCancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
